import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { UiSwitchList } from "../../../_uiComponents/common/form/UiSwitch";
import UiTableBody from "../../../_uiComponents/common/table/UiTableBody";
import UiTableHead from "../../../_uiComponents/common/table/UiTableHead";
import UiTableWrapper from "../../../_uiComponents/common/table/UiTableWrapper";
import {
     ApprovedIcon,
     NotApprovedIcon,
     GridStatus,
} from "../../../_uiComponents/common/DataGridComponents";

import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { Context } from "../../../../_context/Store";
import { UiAccordian } from "../../../_uiComponents/common/form/UiToggleArea";
import IncentiveFilterForm from "../forms/IncentiveFilterForm";
import { SearchBarWr } from "../../../_uiComponents/common/form/UiInputComponents";
import {
     incentiveListRequest,
     incentiveDeleteRequest,
     incentiveSearchListRequest,
     incentiveChangeStatusRequest,
} from "../../../../_redux/_actions";
import { incentiveConfig } from "../module.config";
import { dateFormatter } from "../../../../_helpers/dateFormatter";

import UiTableProgressBar from "../../../_uiComponents/common/table/UiTableProgressBar";

import { contextApiActions } from "../../../../_redux/_constants";
import IncentiveRowManagement from "./IncentiveRowManagement";
import {
     UiGridType,

} from "../../../_uiComponents/common/DataGridComponents";

function descendingComparator(a, b, orderBy) {
     if (b[orderBy] < a[orderBy]) {
          return -1;
     }
     if (b[orderBy] > a[orderBy]) {
          return 1;
     }
     return 0;
}

function getComparator(order, orderBy) {
     return order === "desc"
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
     const stabilizedThis = array.map((el, index) => [el, index]);
     stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
               return order;
          }
          return a[1] - b[1];
     });
     return stabilizedThis.map((el) => el[0]);
}

export default function IncentiveManagement(props) {
     const [page, setPage] = React.useState(1);
     const [rowsPerPage, setRowsPerPage] = React.useState(5);
     const tableRowId = useRef();

     const actionDispatch = useDispatch();
     const navigate = useNavigate();
     const [state, dispatch] = useContext(Context);

     const ACTIVE_STATUS_CODE = 1;
     const INACTIVE_STATUS_CODE = 0;

     useEffect(() => {
          getIncentiveTableList();
     }, [page, rowsPerPage]);

     const getIncentiveTableList = () => {
          actionDispatch(
               incentiveSearchListRequest({
                    page: page,
                    pageSize: rowsPerPage,
               }),
          );
     };

     const getFilteredIncentiveList = (data) => {
          actionDispatch(
               incentiveSearchListRequest({
                    page: page,
                    pageSize: rowsPerPage,
                    ...data,
               }),
          );
     };

     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(event.target.value);
          setPage(1);
     };

     const { tableList, totalRecords } = useSelector((state) => {
          return {
               tableList: state.incentive.list.data,
               totalRecords: state.incentive.list.totalRecords,
          };
     });

     const deleteIncentive = (id) => {
          dispatch({
               type: contextApiActions.UI_CONFIRMATION_TOGGEL,
               payload: {
                    show: true,
                    okFunction: () => {
                         actionDispatch(
                              incentiveDeleteRequest({
                                   id,
                                   page: page,
                                   pageSize: rowsPerPage,
                              }),
                         );
                    },
               },
          });
     };

     const [order, setOrder] = React.useState("asc");
     const [orderBy, setOrderBy] = React.useState();
     const [open, setOpen] = React.useState(false);
     const [active, setActive] = React.useState();
     const [editModal, setEditModal] = React.useState(false);

     const manageOpen = (clickedIndex) => {
          if (active === clickedIndex) {
               setActive(null);
               setOpen(true);
          } else {
               setActive(clickedIndex);
               setOpen(true);

          }
     };

     const getTableRowValueList = (searchValue = "") => { };

     //Pagination
     const handleChangePage = (event, newPage) => {
          setPage(newPage + 1);
     };

     //Sorting
     const handleRequestSort = (event, property) => {
          const isAsc = orderBy === property && order === "asc";
          setOrder(isAsc ? "desc" : "asc");
          setOrderBy(property);
     };

     //Add row modal
     const [openAddFieldModal, setOpenAddFieldModal] = React.useState(false);
     const subTableModalOpen = () => setOpenAddFieldModal(true);
     const handleClose = () => setOpenAddFieldModal(false);

     //Data sorting
     const sortingRows = React.useMemo(
          () => stableSort(tableList, getComparator(order, orderBy)),
          [order, orderBy, page, rowsPerPage, tableList],
     );

     //Drag and drop reorder
     const reorder = (list, startIndex, endIndex) => {
          const result = Array.from(list);
          const [removed] = result.splice(startIndex, 1);
          result.splice(endIndex, 0, removed);
          return result;
     };

     //Switch function
     const handleChangeActiveInactive = (id, value) => {
          actionDispatch(
               incentiveChangeStatusRequest({
                    id,
                    value,
                    page: page,
                    pageSize: rowsPerPage,
               }),
          );
     };

     return (
          <>
               <UiAccordian>
                    <SearchBarWr>
                         <IncentiveFilterForm
                              getFilteredIncentiveList={
                                   getFilteredIncentiveList
                              }
                         />
                    </SearchBarWr>
               </UiAccordian>
               <div className="sba-table-main-wr sba-incentive-mng-tbl">
                    <UiTableWrapper>
                         <UiTableHead
                              headings={incentiveConfig.list.tableMapper}
                              order={order}
                              orderBy={orderBy}
                              onRequestSort={handleRequestSort}
                         />

                         <UiTableBody>
                              {sortingRows.map((row, index) => (
                                   <>
                                        <TableRow
                                             key={row.id}
                                             sx={{
                                                  "&:last-child td, &:last-child th":
                                                       { border: "none" },
                                             }}
                                        >
                                             {incentiveConfig.list.tableMapper.map(
                                                  (headCell, index) => {
                                                       if (headCell.isShow) {
                                                            return headCell.type ==
                                                                 "text" ? (
                                                                 <TableCell align="left">
                                                                      {headCell.isNormalTest ? (
                                                                           row[
                                                                           headCell
                                                                                .id
                                                                           ]
                                                                      ) : (
                                                                           <strong>
                                                                                {
                                                                                     row[
                                                                                     headCell
                                                                                          .id
                                                                                     ]
                                                                                }
                                                                           </strong>
                                                                      )}
                                                                 </TableCell>
                                                            ) : (
                                                                 <>
                                                                      {headCell.type ==
                                                                           "fillLabel" && (
                                                                                <TableCell align="center">
                                                                                     <UiGridType name={row[
                                                                                          headCell
                                                                                               .id
                                                                                     ]} />


                                                                                </TableCell>
                                                                           )}

                                                                      {headCell.type ==
                                                                           "dateTime" && (
                                                                                <TableCell align="center">

                                                                                     {dateFormatter(
                                                                                          row[
                                                                                          headCell
                                                                                               .id
                                                                                          ],
                                                                                     )}

                                                                                </TableCell>
                                                                           )}

                                                                      {headCell.id ==
                                                                           "participation" && (
                                                                                <TableCell align="center">
                                                                                     <UiTableProgressBar
                                                                                          completed={
                                                                                               (row.activeParticipants / row.totalParticipants) * 100
                                                                                          }
                                                                                     />
                                                                                </TableCell>
                                                                           )}

                                                                      {headCell.id ==
                                                                           "status" && (
                                                                                <TableCell align="center">
                                                                                     <GridStatus
                                                                                          status={
                                                                                               row.status
                                                                                          }
                                                                                     />
                                                                                </TableCell>
                                                                           )}

                                                                      {headCell.id ==
                                                                           "isApproved" && (
                                                                                <TableCell align="center">
                                                                                     {row.isApproved ? (
                                                                                          <ApprovedIcon />
                                                                                     ) : (
                                                                                          <NotApprovedIcon />
                                                                                     )}
                                                                                </TableCell>
                                                                           )}
                                                                      {headCell.id ==
                                                                           " " && (
                                                                                <TableCell align="left"></TableCell>
                                                                           )}
                                                                 </>
                                                            );
                                                       } else {
                                                       }
                                                  },
                                             )}
                                             {/* <TableCell align="center">
                                                  <Button
                                                       size="small"
                                                       variant="outlined"
                                                       endIcon={
                                                            active == index &&
                                                                 open ? (
                                                                 <KeyboardArrowUpIcon />
                                                            ) : (
                                                                 <KeyboardArrowDownIcon />
                                                            )
                                                       }
                                                       onClick={() => {
                                                            manageOpen(
                                                                 index,
                                                                 row.id,
                                                            );
                                                       }}
                                                  >
                                                       Approval
                                                  </Button>
                                             </TableCell> */}

                                             <TableCell align="center">
                                                  <UiSwitchList
                                                       checked={row.active}
                                                       handleChange={() => {
                                                            handleChangeActiveInactive(
                                                                 row.id,
                                                                 row.active
                                                                      ? INACTIVE_STATUS_CODE
                                                                      : ACTIVE_STATUS_CODE,
                                                            );
                                                       }}
                                                       name={"changeStatus"}
                                                  />
                                             </TableCell>
                                             <TableCell
                                                  align="right"
                                                  sx={{ width: "110px" }}
                                             >
                                                  <div className="sbt-data-grid__action-bar">
                                                       {/* <InfoIcon className="sba-grid-info-icon" />
                                                       <Tooltip
                                                            title="Edit"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 aria-label="Edit"
                                                                 onClick={() =>
                                                                      navigate(
                                                                           "/app/incentive-data-manage/add/" +
                                                                           row.id,
                                                                      )
                                                                 }
                                                                 sx={{
                                                                      ml: 1.5,
                                                                 }}
                                                            >
                                                                 <EditIcon />
                                                            </IconButton>
                                                       </Tooltip> */}
                                                       <Tooltip
                                                            title="Delete"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 onClick={() => {
                                                                      deleteIncentive(
                                                                           row.id,
                                                                      );
                                                                 }}
                                                                 aria-label="delete"
                                                                 sx={{
                                                                      ml: 0.5,
                                                                 }}
                                                            >
                                                                 <DeleteIcon color="error" />
                                                            </IconButton>
                                                       </Tooltip>
                                                  </div>
                                             </TableCell>
                                        </TableRow>
                                        <TableRow>
                                             <TableCell
                                                  style={{
                                                       paddingBottom: 0,
                                                       paddingTop: 0,
                                                       border: "none",
                                                       background: "#f9f8f8",
                                                       borderBottom: "none",
                                                  }}
                                                  colSpan={12}
                                             >
                                                  <Collapse
                                                       in={
                                                            active == index &&
                                                            open
                                                       }
                                                       timeout="auto"
                                                       unmountOnExit
                                                  >
                                                       {active == index &&
                                                            open && (
                                                                 <>
                                                                      <IncentiveRowManagement />
                                                                 </>
                                                            )}
                                                  </Collapse>
                                             </TableCell>
                                        </TableRow>


                                   </>
                              ))}
                         </UiTableBody>
                    </UiTableWrapper>
               </div>
               <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 20, 25]}
                    component="div"
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
               />
          </>
     );
}
